<template>
  <Container>
    <h2>{{ title }}</h2>
    <div
      class="
        space-y-12
        sm:divide-y sm:divide-gray-200 sm:space-y-0 sm:-mt-8
        lg:gap-x-8 lg:space-y-0
      "
    >
      <!-- Custom Ultrack ELD -->
      <div class="sm:py-8">
        <div
          class="
            space-y-4
            sm:grid sm:grid-cols-4 sm:items-start sm:gap-12 sm:space-y-0
          "
        >
          <div class="aspect-w-2 aspect-h-2">
            <img class="object-cover rounded-md" src="@/assets/ui.jpg" alt="" />
          </div>
          <div class="sm:col-span-3 lg:col-span-2 flex flex-col h-full">
            <div class="space-y-4">
              <div class="text-lg leading-6 font-medium space-y-1">
                <h2 class="text-2xl md:text-3xl mb-0 leading-5">Ultrack ELD</h2>
                <p class="text-accent md:text-lg">Windows 11 ELD</p>
              </div>
              <div class="text-lg">
                <p class="text-gray-500">
                  ELD offering user friendly, secure interactions, best in class
                  inspection reports.
                </p>
              </div>
            </div>
            <div class="mt-auto pt-7">
              <router-link
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  md:px-6 md:py-3
                  border border-transparent
                  text-base
                  font-medium
                  rounded-md
                  shadow-sm
                  text-white
                  bg-accent
                  hover:bg-accent-light
                "
                to="/products/eld"
              >
                Learn more
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-for="person in people" :key="person.name" class="sm:py-8">
        <div
          class="
            space-y-4
            sm:grid sm:grid-cols-4 sm:items-start sm:gap-12 sm:space-y-0
          "
        >
          <div class="w-full">
            <img class="object-contain" :src="person.imageUrl" alt="" />
          </div>
          <div class="sm:col-span-3 lg:col-span-2 flex flex-col h-full">
            <div class="space-y-4">
              <div class="text-lg leading-6 font-medium space-y-1">
                <h2 class="text-2xl md:text-3xl mb-0 leading-5">
                  {{ person.name }}
                </h2>
                <p class="text-accent md:text-lg">{{ person.role }}</p>
              </div>
              <div class="text-lg">
                <p class="text-gray-500">{{ person.bio }}</p>
                <p class="text-gray-900 mt-2" style="font-weight:500" v-if="person.features != null">{{ person.features }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Button from "../base/Button.vue";
import Container from "@/components/base/Container.vue";
const defaultPeople = [
  {
    name: "Person Name",
    role: "Role",
    imageUrl:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
    bio: "lorem ipsum dolor sit amet, con",
  },
];
export default {
  components: { Container, Button },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    people: {
      type: Array,
      default: () => defaultPeople,
    },
  },
};
</script>
